import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=13274e3e&scoped=true&"
import script from "./restaurant.vue?vue&type=script&lang=js&"
export * from "./restaurant.vue?vue&type=script&lang=js&"
import style0 from "./restaurant.vue?vue&type=style&index=0&id=13274e3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13274e3e",
  null
  
)

export default component.exports